var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatWideLetter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.8889,
    height: 40,
    transform: "translate(0.777344)",
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6672_16201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.0957 12.1765C7.0957 11.0719 7.99113 10.1765 9.0957 10.1765L35.3159 10.1765C35.865 10.1765 36.3899 10.4022 36.7675 10.8007L42.2941 16.6318C42.6463 17.0033 42.8425 17.4957 42.8425 18.0076V27.7352C42.8425 28.8398 41.9471 29.7352 40.8425 29.7352H9.0957C7.99113 29.7352 7.0957 28.8398 7.0957 27.7352V12.1765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0954 22.8074V24.0729H37.3593V22.8074H36.0954ZM35.5898 22.7758C35.5898 22.5137 35.802 22.3013 36.0638 22.3013H37.3909C37.6527 22.3013 37.8649 22.5137 37.8649 22.7758V24.1045C37.8649 24.3666 37.6527 24.579 37.3909 24.579H36.0638C35.802 24.579 35.5898 24.3666 35.5898 24.1045V22.7758Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0954 25.5911V26.8565H37.3593V25.5911H36.0954ZM35.5898 25.5595C35.5898 25.2974 35.802 25.085 36.0638 25.085H37.3909C37.6527 25.085 37.8649 25.2974 37.8649 25.5595V26.8882C37.8649 27.1503 37.6527 27.3627 37.3909 27.3627H36.0638C35.802 27.3627 35.5898 27.1503 35.5898 26.8882V25.5595Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8767 22.8074V24.0729H40.1406V22.8074H38.8767ZM38.3711 22.7758C38.3711 22.5137 38.5833 22.3013 38.8451 22.3013H40.1722C40.4339 22.3013 40.6461 22.5137 40.6461 22.7758V24.1045C40.6461 24.3666 40.4339 24.579 40.1722 24.579H38.8451C38.5833 24.579 38.3711 24.3666 38.3711 24.1045V22.7758Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6239 25.085C38.7635 25.085 38.8767 25.1983 38.8767 25.338V26.0973C38.8767 26.2371 38.7635 26.3504 38.6239 26.3504C38.4843 26.3504 38.3711 26.2371 38.3711 26.0973V25.338C38.3711 25.1983 38.4843 25.085 38.6239 25.085Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.635 25.085C39.7746 25.085 39.8878 25.1983 39.8878 25.338V27.1096C39.8878 27.2494 39.7746 27.3627 39.635 27.3627H38.6239C38.4843 27.3627 38.3711 27.2494 38.3711 27.1096C38.3711 26.9699 38.4843 26.8565 38.6239 26.8565H39.3822V25.338C39.3822 25.1983 39.4954 25.085 39.635 25.085Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3809 25.8449C39.3809 25.7051 39.494 25.5918 39.6336 25.5918H40.392C40.5316 25.5918 40.6448 25.7051 40.6448 25.8449C40.6448 25.9847 40.5316 26.098 40.392 26.098H39.6336C39.494 26.098 39.3809 25.9847 39.3809 25.8449Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3934 26.3505C40.533 26.3505 40.6462 26.4638 40.6462 26.6035V27.1097C40.6462 27.2495 40.533 27.3628 40.3934 27.3628C40.2538 27.3628 40.1406 27.2495 40.1406 27.1097V26.6035C40.1406 26.4638 40.2538 26.3505 40.3934 26.3505Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0957 12.1763C7.0957 11.0717 7.99113 10.1763 9.0957 10.1763H17.073V29.735H9.0957C7.99113 29.735 7.0957 28.8395 7.0957 27.735V12.1763Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0845,
    cy: 16.8177,
    rx: 2.48097,
    ry: 2.48394,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0957 21.4642L16.4434 28.4766C16.8397 28.7739 17.073 29.2405 17.073 29.7359H9.0957C7.99113 29.7359 7.0957 28.8405 7.0957 27.7359V21.4642Z",
    fill: "#AEAFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 21.8378L7.09499 28.3875C7.09499 29.1314 7.69808 29.7345 8.44202 29.7345H17.0723V21.8378Z",
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9785,
    y: 13.48,
    width: 14.4756,
    height: 2.206,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9785,
    y: 17.1075,
    width: 10.6749,
    height: 0.868406,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9785,
    y: 18.5898,
    width: 12.3516,
    height: 0.868406,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9785,
    y: 20.0721,
    width: 11.234,
    height: 0.868406,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9785,
    y: 21.8823,
    width: 10.6749,
    height: 0.868406,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9785,
    y: 23.3646,
    width: 12.3516,
    height: 0.868406,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9785,
    y: 24.8469,
    width: 11.234,
    height: 0.868406,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1445 10.1765L42.8419 17.2099H38.1445C37.04 17.2099 36.1445 16.3144 36.1445 15.2099V10.1765Z",
    fill: "#4F5B94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6672_16201",
    x: 3.0957,
    y: 8.17627,
    width: 43.7461,
    height: 27.5596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.0588235 0 0 0 0 0.14902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6672_16201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6672_16201",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatWideLetter);
export default __webpack_public_path__ + "static/media/format-wide-letter.95391c679e29e11c05576621691a29f9.svg";
export { ForwardRef as ReactComponent };